<app-lms-modal-frame [title]="'Override Report'" [pageHeadWidth]="500">
  <div modal-body class="p-0">
    <section *ngIf="overrideList.length > 0" class="override-section">

      <!-- ── Visible / paginated table ── -->
      <div class="table-panel">
        <lms-table-wrapper [config]="config">
          <table class="override-table table-auto w-100">
            <caption class="table-caption">Override Log</caption>
            <thead class="sticky-thead">
              <tr>
                <th scope="col">Date / Time</th>
                <th scope="col">Branch</th>
                <th scope="col">Role</th>
                <th scope="col">Override by</th>
                <th scope="col">Override type</th>
                <th scope="col">ID number</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let log of overrideList | paginate: config" class="override-row">
                <td data-label="Date / Time"   class="col-date">{{ log?.date | date: 'yyyy/MM/dd' }}</td>
                <td data-label="Branch"        >{{ log.branchName }}</td>
                <td data-label="Role"          >
                  <span class="role-badge">{{ log.role }}</span>
                </td>
                <td data-label="Override by"   class="col-person">{{ log.overrideBy }}</td>
                <td data-label="Override type" >
                  <span class="override-badge">{{ log.overrideType }}</span>
                </td>
                <td data-label="ID number"     class="col-id">{{ log.idNumber }}</td>
              </tr>
            </tbody>
          </table>
        </lms-table-wrapper>
      </div>

      <!-- ── Hidden full table for Excel export ── -->
      <div class="export-table-wrapper" #TABLE>
        <table #table hidden="true">
          <caption>Override Log Results</caption>
          <thead>
            <tr>
              <th scope="col">Date/Time</th>
              <th scope="col">Branch Name</th>
              <th scope="col">Role</th>
              <th scope="col">Override by</th>
              <th scope="col">Override Type</th>
              <th scope="col">ID Number</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let log of overrideList">
              <td>{{ log?.date }}</td>
              <td>{{ log.branchName }}</td>
              <td>{{ log.role }}</td>
              <td>{{ log.overrideBy }}</td>
              <td>{{ log.overrideType }}</td>
              <td>{{ log.idNumber }}</td>
            </tr>
          </tbody>
        </table>
      </div>

    </section>
  </div>

  <div modal-actions class="action-bar">
    <button class="btn-action btn-export" (click)="exportLogsToExcel()">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
           fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
        <polyline points="7 10 12 15 17 10"/>
        <line x1="12" y1="15" x2="12" y2="3"/>
      </svg>
      Export to Excel
    </button>
    <button class="btn-action btn-close-modal" type="button" (click)="close()">Close</button>
  </div>
</app-lms-modal-frame>
